import React, { useState } from 'react'

/** Single accordion section: title, optional badge, children when open. */
export function AccordionSection({ title, children, defaultOpen = false, badge }) {
  const [open, setOpen] = useState(defaultOpen)
  return (
    <div className="border-b border-white/10 last:border-0">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="flex w-full items-center justify-between gap-2 py-4 text-left text-sm font-medium text-white transition hover:text-white/90"
        aria-expanded={open}
      >
        <span>{title}</span>
        {badge != null && <span className="text-xs text-white/50">{badge}</span>}
        <span className="text-white/50 transition-transform" aria-hidden>
          {open ? '▼' : '▶'}
        </span>
      </button>
      {open && <div className="pb-4 pt-0">{children}</div>}
    </div>
  )
}

export default AccordionSection
